let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page000_game0/img/bcg.jpg',
    pos: {
      x: 183,
      y: 0,
    },
    width: 1554,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    {
      src: 'games/page000_game0/audio/5_rabbit.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game0/img/audioOn.png', iconOff: 'games/page000_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '50px',
      height: '50px',
      pos: {
        y: 390,
        x: 1422,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game0/audio/6_bear.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game0/img/audioOn.png', iconOff: 'games/page000_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '50px',
      height: '50px',
      pos: {
        y: 406,
        x: 787,
      },
      unit: 'px',
    },
    {
      src: 'games/page000_game0/audio/7_mole.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page000_game0/img/audioOn.png', iconOff: 'games/page000_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '50px',
      height: '50px',
      pos: {
        y: 315,
        x: 1091,
      },
      unit: 'px',
    },
  ],
};

export default elements;
